import React from "react";
import LeadCaptureForm from "@/components/LeadCaptureForm";
import { Sparkles } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export default function Customize() {
  const { t } = useI18n();
  return (
    <div data-testid="customize-page">
      <div className="bg-gradient-to-b from-emerald-50/40 to-white border-b border-slate-200">
        <div className="nc-container py-12 md:py-16 text-center">
          <span className="nc-chip"><Sparkles className="w-3.5 h-3.5" /> {t("customize.chip")}</span>
          <h1 className="mt-4 text-3xl md:text-5xl font-semibold tracking-tight text-slate-900">{t("customize.title")}</h1>
          <p className="mt-3 text-slate-600 max-w-2xl mx-auto">{t("customize.sub")}</p>
        </div>
      </div>
      <div className="nc-container py-10 max-w-3xl">
        <LeadCaptureForm source="customize" dataTestidPrefix="customize" allowNonRectangular />
      </div>
    </div>
  );
}
